import {
  faCheckCircle,
  faCircle,
  faTimesCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { AssignmentState } from 'src/apis/monolith/types';
import { Colors } from 'src/styles';
import { labelsToOptions } from 'src/utils/labels-to-options';

type Props = { value: AssignmentState };

export const AssignmentBadge = memo<Props>(({ value }) => {
  switch (value) {
    case 'APPROVED':
      return (
        <div>
          <FontAwesomeIcon
            icon={faCheckCircle}
            aria-hidden
            color={Colors.success}
          />{' '}
          <span>Approved</span>
        </div>
      );
    case 'NOT_APPROVED':
      return (
        <div>
          <FontAwesomeIcon icon={faCircle} aria-hidden color={Colors.warning} />{' '}
          <span>Waiting for Approval</span>
        </div>
      );
    case 'CANCELED':
      return (
        <div>
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          <span>Cancelled</span>
        </div>
      );
    case 'PENDING':
      return (
        <div>
          <FontAwesomeIcon icon={faCircle} aria-hidden color={Colors.warning} />{' '}
          <span>Temporarily Disabled</span>
        </div>
      );
  }
});

export const assignmentStateLabels: { [key in AssignmentState]: string } = {
  APPROVED: 'Approved',
  NOT_APPROVED: 'Waiting for Approval',
  CANCELED: 'Cancelled',
  PENDING: 'Temporarily Disabled',
};

export const assignmentStateTag = (value: string) => {
  switch (value) {
    case 'APPROVED':
    case 'NOT_APPROVED':
    case 'CANCELED':
    case 'PENDING':
      return assignmentStateLabels[value];
  }
};

export const assignmentStateOptions = labelsToOptions(assignmentStateLabels);
